
import AnalysisIndex from './index.vue'

import * as serviceReporting from './serviceReporting'
import * as OneInfo from './info'
import * as FourInfo from './info'
import * as FiveInfo from './info'
import * as ThreeInfo from './info'
import * as SevenInfo from './info'


let a = Object.assign({ AnalysisIndex, },  serviceReporting, OneInfo, FourInfo, FiveInfo, ThreeInfo, SevenInfo);
export default a;
